import { render, staticRenderFns } from "./CollectionResident.vue?vue&type=template&id=077984cc&scoped=true&"
import script from "./CollectionResident.vue?vue&type=script&lang=ts&"
export * from "./CollectionResident.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionResident.vue?vue&type=style&index=0&id=077984cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077984cc",
  null
  
)

export default component.exports